export const BROWSER = "browser";
export const WINDOWS = "windows";
export const LINUX = "linux";
